import React, { useEffect, useState } from "react";
import { BreadCrumbSecttion } from "../component/BreadCrumbSecttion";
import Footer from "../component/Footer";
import OtherService from "../services/Other";
import { Card, Col, Container, Row } from "react-bootstrap";
import Loader from "../component/Loader";
import Header from "../component/Header";
import DOMPurify from "dompurify";
import { parseSafeHtml } from "../utils/safeHtmlParser";

const ContactUs = () => {
  const [isContactData, setisContactData] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const userGuideDataFetch = async () => {
      try {
        // const token = localStorage.getItem('access_token')
        const responseUserGuide = await OtherService.contact();
        setisContactData(responseUserGuide.data.contactDetails);
        setLoading(false);
      } catch (e) {
        console.error("Error");
      }
    };
    userGuideDataFetch();
  }, []);
  return (
    <>
      {loading && <Loader />}

      <BreadCrumbSecttion pageTitle="Contact Us" currentPageName="Contact Us" />
      <section className="padTop50">
        <div className="dashboard-details">
          <Container>
            <Row>
              <Col xs={12}>
                <section className="padTop50">
                  <div className="userInfoBox">
                    <Card className="p-3">
                      <h4>TSE Details</h4>
                      {/* <div
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(`
                                <p>${isContactData?.TSE_name ?? "Not Available"}</p>
                                <p>TSE Phone: ${isContactData?.TSE_phone ?? "Not Available"}</p>`),
                        }}
                      ></div> */}
                      <div>{parseSafeHtml(`
                        <p>${isContactData?.TSE_name ?? "Not Available"}</p>
                        <p>TSE Phone: ${isContactData?.TSE_phone ?? "Not Available"}</p>
                      `)}
                      </div>

                    </Card>
                    <Card className="p-3 mt-4">
                      <h4>Corporate office</h4>
                      {/* <div
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(`
                                <p>${isContactData?.Corporate_Office_Address ?? "Not Available"}</p>
                                <p>${isContactData?.Helpline_email ?? "Not Available"}</p>`)
                        }}
                      ></div> */}
                      <div>
                        {parseSafeHtml(`<p>${isContactData?.Corporate_Office_Address ?? "Not Available"}</p>`)}
                        {parseSafeHtml(`<p>${isContactData?.Helpline_email ?? "Not Available"}</p>`)}
                      </div>
                    </Card>
                  </div>
                </section>
              </Col>
            </Row>
          </Container>
        </div>
      </section>
    </>
  );
};

export default ContactUs;
